import React, {Component} from 'react';
import IconWithCaption from '../../components/IconWithCaption';

import './SideBar.css';
import InitialsIcon from '../../components/InitialsIcon';

import AdminIcon from '../AdminIcon';
import AccountService from '../../api/services/AccountService';
import PendingBadge from "../pending/PendingBadge";



export default class SideBar extends Component{

    constructor(props){
        super(props);

        let account = new AccountService();

        this.state = {
            selected:this.props.value || 'calendar',
            username: account.fullName
        }




        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(icon){

        if(icon == this.state.selected) return;

        this.setState({selected: icon});
        if(this.props.onChange){
            this.props.onChange(icon);
        }
    }

    render(){
        return(
            <div className='side-bar'>
                <div className="side-bar-icons">
                    <SideBarButton selected={this.state.selected} icon='calendar' caption='calendar' onClick={this.handleButtonClick}  />
                    <SideBarButton selected={this.state.selected} icon='pendingTab' caption='pending' onClick={this.handleButtonClick}><PendingBadge /></SideBarButton>
                    <SideBarButton selected={this.state.selected} icon='clients' caption='clients' onClick={this.handleButtonClick}  />
                    <SideBarButton selected={this.state.selected} icon='dr' caption='doctors' onClick={this.handleButtonClick}  />
                    <SideBarButton selected={this.state.selected} icon='settings' caption='settings' onClick={this.handleButtonClick}  />
                    {/*<SideBarButton selected={this.state.selected} id='followups' icon='clock' caption='Follow Ups' onClick={this.handleButtonClick}  />*/}
                </div>

                <AdminIcon className='account-icon' />
            </div>
        )
    }
}



class SideBarButton extends Component{

    handleClick(){
        if(this.props.onClick){
            this.props.onClick(this.props.id || this.props.icon);
        }
    }

    render(){
        let selected = (this.props.selected == this.props.icon) || (this.props.selected == this.props.id);
        return(
            <div className={'side-bar-button table hmax align-middle align-center ' + ((selected)? 'selected': '')} onClick={()=> this.handleClick()}>
                <div>
                    <div className='select-indicator'></div>
                    <div><IconWithCaption icon={this.props.icon} caption={this.props.caption} />{this.props.children}</div>
                </div>
            </div>
        )
    }
}

class Badge extends Component {
    render(){
        return (
            <div className={'btn-badge'}>{this.props.children}</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Appointments/SideBar.js